export default "__VITE_ASSET__BUXCgiwK__"